<template>
<v-container fluid class="pa-0">
    <!-- Associative Tab --------------------------------------------------------------------------------------------------------->
    <v-card fluid id="taskZone">
        <v-card-text class="pa-1">
            <v-form ref="userForm" :disabled="disableForm" lazy-validation>
                    <v-row no-gutters row wrap class="ma-0 mt-2">
                    <v-col cols="8" md="8" class="pl-2 pr-2">
                        <DatePicker v-if="!loading.fetchData" v-model="item.tsk_date_plan" label="Date" :objectForm="item" fieldName='tsk_date_plan'></DatePicker>
                    </v-col>
                    <v-col cols="4" md="4" class="pl-2 pr-2 pb-2">
                        <v-text-field label="H:M" outlined dense class="rounded-lg" v-model="item.tsk_time_plan" type="time" hide-details></v-text-field>
                    </v-col>
                    <!--<v-col cols="8" md="8" class="pl-2 pr-2">
                        <DatePicker v-model="item.tsk_date_end" label="Date de fin" :objectForm="item" fieldName='tsk_date_end'></DatePicker>
                    </v-col>
                    <v-col cols="4" md="4" class="pl-2 pr-2">
                        <v-text-field label="H:M" outlined dense class="rounded-lg" v-model="item.tsk_time_end" type="time"></v-text-field>
                    </v-col>-->

                    <v-col cols="12" md="12" class="pl-2 pr-2" v-show="siteItem.sit_typ_id == 'SIT09'">
                        <v-select v-if="stateListById[item.tsk_sta_id]" :disabled="( !($root.$permissions.Task.before) || disableForm)"
                            :dense="fieldStyle.dense" :outlined="fieldStyle.outlined" item-text="sta_label" item-value="sta_id"
                            :items="stateListByGroup['TSK']" v-model="item.tsk_sta_id" label="Statut" single-line>
                            <template v-slot:prepend><v-icon :color="stateListById[item.tsk_sta_id].sta_color">mdi-file-tree</v-icon></template>
                        </v-select>
                    </v-col>
                    <!--<v-col cols="12" md="6" class="pl-2 pr-2">
                    <v-select 
                        :dense="fieldStyle.dense" :outlined="fieldStyle.outlined" item-text="typ_name" item-value="typ_id"
                        :items="typeListByGroup['TSK']" v-model="item.tsk_typ_id" label="Type" single-line>
                        <template v-slot:prepend><v-icon :color="typeListById[item.tsk_typ_id].typ_color">mdi-progress-check</v-icon></template>
                    </v-select>
                    </v-col>-->
                    <v-col cols="12" md="12" class="pl-2 pr-2" >
                        <v-chip v-show="!editTaskType" v-for="tskTyp in item.tasktypes" class="mr-2" small :color="tskTyp.tty_color" label outlined :key="'id-' + tskTyp.tty_id" @dblclick="editTaskType = !editTaskType">
                            {{tskTyp.tty_name}}
                        </v-chip>
                        <!-- siteItem.livestocks 
                        <AutocompleteMulti v-if="editTaskType"
                            :title="'Actions'" :ressource="'tasktypes'" :disabled="disableForm"
                            :listObject.sync="item._pivot.tasktypes" :listParent.sync="autoCompleteSource.listTaskTypeItemSource" 
                            :fields="{ 
                                index: 'tty_id', text:'tty_name', autofocus: true, deletablechips: true,
                                search:'tty_name', preprendIcon:'mdi-table-merge-cells', multiSelect:true, prefetch: true, params:'' 
                        }"></AutocompleteMulti> -->
                    </v-col>
                    <v-col cols="12" md="6" class="pl-2 pr-2" v-show="siteItem.sit_typ_id == 'SIT09'">
                        <v-text-field outlined dense class="rounded-lg" prepend-icon="mdi-progress-clock" label="Temps prévu" v-model="item.tsk_duration_plan" type="time" suffix="H:M"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="pl-2 pr-2" v-show="siteItem.sit_typ_id == 'SIT09'">
                        <v-text-field outlined dense class="rounded-lg" prepend-icon="mdi-clock-check-outline" label="Temps effectif" v-model="item.tsk_duration" type="time" suffix="H:M"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" class="pl-2 pr-2" v-show="siteItem.sit_typ_id == 'SIT09'">
                        <!--<v-text-field outlined dense class="rounded-lg" prepend-icon="mdi-currency-eur" label="Coût" v-model="item.tsk_amount_ht" type="numeric"></v-text-field>-->
                    </v-col>
                    <v-col cols="12" md="12" class="pl-2 pr-2" v-show="siteItem.sit_typ_id == 'SIT09'">
                        <AutocompleteMulti v-if="!loading.fetchData"
                            :title="'Intervenant'" :ressource="'users'" :disabled="disableForm"
                            :listObject.sync="item._pivot.users" :listParent.sync="autoCompleteSource.userList" 
                            :fields="{
                                index: 'id', text:'lastName,firstName', autofocus: false, deletablechips: true,
                                search:'usr_middleName', preprendIcon:'mdi-account-group', multiSelect:true, prefetch: false, params:'' 
                        }"></AutocompleteMulti>
                    </v-col>
                    <!--<v-col cols="12" md="12" class="pl-2 pr-2" v-show="siteItem.sit_typ_id !== 'SIT02'">
                        <AutocompleteMulti v-if="!loading.fetchData"
                            :title="'Materiel utilisé'" :ressource="'equipments'" :disabled="disableForm"
                            :listObject.sync="item._pivot.equipments" :listParent.sync="autoCompleteSource.listEquipmentItemSource" 
                            :fields="{ 
                                index: 'equ_id', text:'equ_name', autofocus: false, deletablechips: true,
                                search:'equ_name', preprendIcon:'mdi-tools', multiSelect:true, prefetch: true, params:'' 
                        }"></AutocompleteMulti>
                    </v-col>
                    -->
                    <!------------------------------------ Quiz ------------------------------------------------->
                    <v-col cols="12" class="">
                        <TaskQuizForm ref="quizForm" v-if="(!loading.fetchData && siteItem.sit_typ_id !== 'SIT09')" :quiz="'QIZ'" :task.sync="item"/>
                    </v-col>
                </v-row>
            </v-form>            
        </v-card-text>
    </v-card>
    <!-- Save button form -->
    <v-toolbar extended flat color="transparent" class="mb-3">
        <v-btn v-if="(item.tsk_sta_id !== 'TSK07')" rounded color="red" class="mr-3" dark :loading="loading.fetchData" @click.native="deleteItem()" :disabled="false">
        <v-icon left>mdi-trash-can-outline</v-icon>
        </v-btn>
        <!--<v-btn v-if="(item.tsk_sta_id !== 'TSK05' && !disableForm)" rounded color="green" class="mr-3" dark :loading="loading.fetchData" @click.native="item.tsk_sta_id = 'TSK05'; saveItem();" :disabled="false">
            <v-icon left>mdi-record</v-icon>Terminer
        </v-btn>-->
        <v-spacer></v-spacer>
        <!--<v-btn v-if="!disableForm" rounded text color="#595959" dark @click="cancelEdit()"><v-icon left dark>mdi-close</v-icon>Annuler </v-btn>-->
        <v-btn v-if="!disableForm" rounded color="primary" class="mr-3 ml-3" :loading="loading.fetchData" @click.native="saveItem('TSK05')" :disabled="(loading.fetchData) ? true : false">
            <v-icon left>mdi-content-save-outline</v-icon>Terminer
        </v-btn>
        <v-btn v-if="!disableForm && $root.$permissions.Task.destroy" rounded color="secondary" title="Enregistrer" class="mr-3 ml-3" :loading="loading.fetchData" @click.native="saveItem('TSK04')" :disabled="(loading.fetchData) ? true : false">
            <v-icon left>mdi-content-save-edit-outline</v-icon>
        </v-btn>
        <v-btn v-if="disableForm" rounded color="orange" class="mr-3 ml-3" :loading="loading.fetchData" @click.native="unlockItem('TSK04')" :disabled="(loading.fetchData) ? true : false">
            <v-icon left>mdi-lock-open-outline</v-icon>Ré-ouvrir
        </v-btn>
    </v-toolbar>
</v-container>
</template>

<script>
import DatePicker from '@/components/ui/DatePicker'
import AutocompleteMulti from '@/components/ui/AutocompleteMulti'
import TaskQuizForm from '@/components/tasks/TaskQuizForm.vue'
//import DocumentTab from '@/components/documents/DocumentList.vue'

import { mapState, mapWritableState, mapActions } from 'pinia'
import { useTaskStore } from '@/stores/task'
import { useTypeStore } from '@/stores/type'
import { useStateStore } from '@/stores/state'
import { useTaskTypeStore } from '@/stores/tasktype'
import { useUserStore } from '@/stores/user'
import { useSiteStore } from '@/stores/site'
import { useQuizStore } from '@/stores/quiz'
import { useLivestockStore } from '@/stores/livestock'

import { taskUpdateService } from '@/rxjsServices';

export default {
    name: 'task-edit',
    props: [ 'routeState', 'link' ],
    mixins: [ ],
    components: {
        DatePicker, AutocompleteMulti, TaskQuizForm
    },
    computed: {
        ...mapWritableState(useTaskStore, {item: 'item', taskActions: 'actions' }),
        ...mapState(useSiteStore,         { siteItem: 'item' }),
        ...mapState(useTypeStore,         { typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapState(useStateStore,        { stateListByGroup: 'itemListByGroup', stateListById: 'itemListById' }),
        ...mapState(useTaskTypeStore,     { taskTypeList: 'itemList' }),
        ...mapState(useUserStore, {userList: 'itemList', user: 'me' }),
        ...mapState(useQuizStore, {quizItemList: 'itemList', quizItemTree: 'itemTree' }),
        disableForm(){
            return (this.item.tsk_sta_id == 'TSK05')
        }
    },
    data: function () {
        return {
            loading : { fetchData: true },         // Enregistrement en cours...
            fieldStyle: { outlined: true, dense: true },
            activeTab: -1, 
            showTab: false,
            tabItems: [
                { title: 'Fiche',      disabled: false, icon: 'mdi-file-document-multiple-outline'},
                { title: 'Temps',      disabled: !this.isAuthorized(), icon: 'mdi-clock-time-eight-outline'},
                { title: 'Véhicule',   disabled: true, icon: 'mdi-tools'},
                { title: 'Fichiers',   disabled: false, icon: 'mdi-folder-multiple-outline'},
                //{ title: 'Evenements', disabled: false, icon: 'mdi-calendar-alert'},
            ],
            autoComplete: { listTaskTypeItem: {}, },
            autoCompleteSource: { listTaskTypeItemSource: [], userList: [], listEquipmentItemSource: [] },
            unlockedItem: false,
            touchstartX: 0, touchstartY: 0, touchendX: 0, touchendY: 0, 
            radioGroup: 1, radioGroupp: 1,
            editTaskType: false
        }
    },
    async mounted (){
        this.loading.fetchData = true
        this.autoCompleteSource.listTaskTypeItemSource = this.taskTypeList
        this.autoCompleteSource.userList = this.userList

        await this.fetchItem( this.$route.params.tsk_uid, '?include=usercompany,tasktypes,users,equipments,taskquiz' )
        await this.fetchSiteItem( this.$route.params.sit_id, '?ent_sta_id=GEN01&include=livestocks,tasktypes' )
        this.initAction()
        // init form
        if( !(this.$route.params.tsk_uid.length > 8) ){
            this.item.tsk_date_plan = this.$date().format('YYYY-MM-DD')
            this.item.tsk_time_plan = this.$date().format('HH:mm')
            console.log(this.$root.$userInfo)
            if( this.$root.$userInfo.usercompany.cpy_customfields.tty_id_default ){
                const defaultTaskType = this.autoCompleteSource.listTaskTypeItemSource.find(
                    t => t.tty_id === this.$root.$userInfo.usercompany.cpy_customfields.tty_id_default
                )
                if( defaultTaskType ){
                    this.item._pivot.tasktypes.push( defaultTaskType.tty_id )
                } else {
                    this.item._pivot.tasktypes.push( this.autoCompleteSource.listTaskTypeItemSource[0].tty_id )
                }
            } else {
                this.item._pivot.tasktypes.push( this.autoCompleteSource.listTaskTypeItemSource[0].tty_id )
            }

            this.item._pivot.users.push(this.user.id)
            
            this.item.tsk_sit_id = this.$route.params.sit_id
        }

        this.loading.fetchData = false
        this.activeTab = 0
        this.showTab      = ( this.item.tsk_id ) ? true : false

        this.scroll()

    },
    methods: {
        ...mapActions(useTaskStore, { fetchItem: 'fetchItem', updateItem: 'updateItem', storeItem: 'storeItem', destroyItem:'destroyItem', initItem: 'RESET_ITEM', initAction: 'RESET_ACTION' }),
        ...mapActions(useQuizStore, { quizFetchItems: 'fetchItems'}),
        ...mapActions(useSiteStore, { fetchSiteItem: 'fetchItem', resetSiteItem: 'RESET_ITEM' }),
        ...mapActions(useLivestockStore, { updateLivestockItem: 'updateItem' }),
        async saveItem (state) {
            if( !this.item._pivot.tasktypes.length ){
                this.$root.$toast({ text: 'Au moins une tâche doit être selectionnée', color: 'error' })
                return false
            }

            if(state){
                this.item.tsk_sta_id = state
            }
            // ⬇️ Récupération directe depuis l'enfant
            const quizForm = this.$refs.quizForm
            if (quizForm && typeof quizForm.getLivestockDiffs === 'function') {
                this.item.tsk_customfields.tsk_livestockdiff = quizForm.getLivestockDiffs()
            }
            // Enregistrement du formulaire
            this.loading.fetchData = true
            this.item.tsk_tty_id = this.item._pivot.tasktypes[0]
            // Envoi des tasktypesPrev au backend pour créer la tâche enfant (génération PDF atomique)
            if( (state == 'TSK05') && this.taskActions.tasktypesPrev && this.taskActions.tasktypesPrev.length > 0 ){
                if( !this.item._pivot ){
                    this.item._pivot = {}
                }
                this.item._pivot.tasktypesPrev = this.taskActions.tasktypesPrev
            }
            if( this.$route.params.tsk_uid.length > 8 ){
                await this.updateItem()
                taskUpdateService.sendTask(this.item);
            } else {
                await this.storeItem()
                taskUpdateService.sendTask(this.item);
            }

            if( this.taskActions.deadLivestock && Array.isArray(this.taskActions.deadLivestock) && this.taskActions.deadLivestock.length ){
                for (const livestock of this.taskActions.deadLivestock) {
                    this.updateLivestockItem({lst_id: livestock, lst_sta_id: 'LST02' })
                }
            }

            if( !this.unlockedItem ){
                this.$root.$toast({ text: 'Fiche enregistrée !', color: 'success' })
                if( this.taskActions.createAssign ){
                    this.$router.push({ path: '/assignments/0' })
                } else {
                    this.$router.push({ path: this.$route.fullPath.split('/').slice(0, -1).join('/') })
                }
            }

            this.unlockedItem = false
            this.loading.fetchData = false
        },
        async unlockItem(){
            this.$root.$confirm('Supprimer', 'Confirmer la ré-ouverture de l\'action ?', { color: 'red', width: 400 }).then((confirm) => {
                if( confirm ){
                    this.item.tsk_sta_id = 'TSK04'
                    this.unlockedItem = true
                    this.saveItem()
                }
            })
        },
        async deleteItem(){
            this.$root.$confirm('Supprimer', 'Confirmer la suppression ?', { color: 'red', width: 400 }).then((confirm) => {
                if( confirm ){
                    this.item.tsk_sta_id = 'TSK07'
                    this.destroyItem()
                    this.$root.$toast({ color: 'error', top:false, bottom:true, right:false, left:true, text:'Tache supprimée !' })
                    taskUpdateService.sendTask(this.item)
                    this.$router.push({ path: this.$route.fullPath.split('/').slice(0, -1).join('/') })
                }
            })
        },
        async cancelEdit(){
            this.$router.push({ path: this.$route.fullPath.split('/').slice(0, -1).join('/') })
        },
        linkedDocument(doc_id){
            this.item.tsk_doc_id = doc_id
        },
        isAuthorized(){
            return (this.$root.$userInfo.usercompany.cpy_sub_typ_id == 'SUB03' || this.$root.$userInfo.usercompany.cpy_sub_typ_id == 'SUB04')
        },
        startScroll(event){
            this.touchstartX = event.screenX
            this.touchstartY = event.screenY
        },
        scroll () {
            window.onscroll = () => {
                let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight

                if (bottomOfWindow) {
                    this.scrolledToBottom = true // replace it with your code
                }
            }
        }

    }
}
</script>
<style>
.v-tabs--vertical {
  align-items: end;
  flex-direction: column;
}
/*.v-tabs-slider-wrapper {
  left: auto !important;
  right: 0;
}*/
.v-tabs--vertical > .v-tabs-bar .v-tab {
    height: auto;
}
.v-tab {
    justify-content: left;
}
</style>